export const notConfirmedUsersColumns = (t: any) => [
  {
    key: "lastName",
    name: t('notConfirmedUsers.columns.lastName'),
    fieldName: "lastName",
    minWidth: 250,
    maxWidth: 300,
    isResizable: true,
  },
  {
    key: "firstName",
    name: t('notConfirmedUsers.columns.firstName'),
    fieldName: "firstName",
    minWidth: 100,
    maxWidth: 100,
  },
  {
    key: "phone",
    name: t('notConfirmedUsers.columns.phone'),
    fieldName: "phone",
    minWidth: 200,
    maxWidth: 250,
  },
  {
    key: "email",
    name: t('notConfirmedUsers.columns.email'),
    fieldName: "email",
    minWidth: 200,
    maxWidth: 250,
  },
];